export default __webpack_public_path__ + "static/media/freeimage-83035989-web.d88d617a.jpg";